/** @format */

/** Keep only recent GPS points for animation — unbounded grids were the main heap leak. */
export const MAX_LAT_LNG_GRID = 40;
/** Bootstrap only needs a last known position; live WS fills motion later. */
export const BOOTSTRAP_LAT_LNG_GRID = 1;

export function trimLatLngGrid(grid, max = MAX_LAT_LNG_GRID) {
  if (!Array.isArray(grid) || grid.length <= max) return grid;
  return grid.slice(0, max);
}
